// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
const images = require.context('../images', true)
import { ToggleController, UnitSizeController, UnitSizeInfoController } from "controllers"
import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle'

window.$ = window.jQuery = $

Rails.start()
ActiveStorage.start()
